// U+2068 FIRST STRONG ISOLATE / U+2069 POP DIRECTIONAL ISOLATE.
// Wraps text so its internal bidi direction is isolated from the surrounding
// RTL paragraph. Use for Latin candidate/election names embedded in RTL prose.
export const isolate = (text: string): string => `⁨${text}⁩`;
